import BeginConfigure from 'page/BeginConfigure';
import BeginGenerate from 'page/BeginGenerate';
import BeginGoLive from 'page/BeginGoLive';
import BeginIntegrate from 'page/BeginIntegrate';
import BeginOverview from 'page/BeginOverview';
import Browse from 'page/Browse';
import CollectData from 'page/CollectData';
import Default from 'page/Default';
import Icons from 'page/internal/Icons';
import Help from 'page/Help';
import Learn from 'page/Learn';
import ManageApiVersions from 'page/ManageApiVersions';
import ManageEnvironments from 'page/ManageEnvironments';
import React from 'react';
import Server from 'data/Server';
import dashboard_placeholder from 'img/dashboard_placeholder.png';


const NAV_LINKS = Object.freeze([
  {
    label: 'Begin',
    path: '/begin',
    children: [
      {
        label: 'Overview',
        path: '/begin/overview',
        component: BeginOverview,
      },
      {
        label: 'Configure',
        path: '/begin/configure',
        component: BeginConfigure,
      },
      {
        label: 'Generate',
        path: '/begin/generate',
        component: BeginGenerate,
      },
      {
        label: 'Integrate',
        path: '/begin/integrate',
        component: BeginIntegrate,
      },
      {
        label: 'Go Live',
        path: '/begin/go_live',
        component: BeginGoLive,
      },
    ],
  },
  {
    label: 'Manage',
    path: '/manage',
    children: [
      {
        label: 'Environments',
        path: '/manage/environments',
        component: ManageEnvironments,
      },
      {
        label: 'API Versions',
        path: '/manage/api_versions',
        component: ManageApiVersions,
      },
      {
        label: 'Firmware Versions',
        path: '/manage/firmware_versions',
        component: Default,
      },
      {
        label: 'Custom Hooks',
        path: '/manage/custom_hooks',
        component: Default,
        componentProps: {
          content: 'Integration points for custom behaviors, triggers, alerts, algorithms.',
        }
      },
      {
        label: 'Web Bluetooth',
        path: '/manage/web_bluetooth',
        /* TODO: get the size of the chart nicer */
        component: CollectData,//Default,
      },
      {
        label: 'AI Lab',
        path: '/manage/ai_lab',
        component: Learn,//Default,
        componentProps: {
          content: 'Interface for training, evaluating, and deploying ML/AI models.',
        },
      },
      {
        label: 'Auditing',
        path: '/manage/auditing',
        component: Default,
        componentProps: {
          content: 'View the history of access and changes.',
        },
      },
      {
        label: 'Key Vault',
        path: '/manage/key_vault',
        component: Default,
      },
    ],
  },
  {
    label: 'Analyze',
    path: '/analyze',
    children: [
      {
        label: 'Dashboard',
        path: '/analyze/dashboard',
        component: Default,
        componentProps: {
          content: (
            <div className='section'>
              <img
                  src={dashboard_placeholder}
                  alt="Dashboard"
                  style={{width: '100%', maxWidth: '800px'}} />
            </div>
          ),
        },
      },
      {
        label: 'Monitoring',
        path: '/analyze/monitoring',
        component: Default,
      },
      {
        label: 'Fleet',
        path: '/analyze/fleet',
        component: Default,
      },
      {
        label: 'Data Viewer',
        path: '/analyze/data_viewer',
        /* TODO: get the charts to auto-fit by default */
        /* TODO: migrate data to be in April */
        component: Browse,//Default,
      },
      {
        label: 'Integrations and Export',
        path: '/analyze/integration',
        component: Default,
      },
    ],
  },
  {
    label: 'Help',
    path: '/help',
    component: Help,
  },
  {
    label: 'Internal',
    showIf: () => false,
    path: '/_i',
    children: [
      {
        label: 'Icons',
        path: '/_i/icons',
        component: Icons,
      },
    ]
  },
]);


class Sitemap {
  constructor() {
    this.server = new Server.Factory().create();
  }

  getTopnavItems() {
    return NAV_LINKS;
  }

  getVisibleSidenavItems() {
    if (!this.server.user_email()) {
      return [];
    }
    const currentTopnavItem = NAV_LINKS.find(
        i => window.location.pathname.match('^' + i.path));
    if (currentTopnavItem) {
      return currentTopnavItem.children || [];
    }
    return [];
  }

  /** Returns the next URL within a list of children. */
  getNextUrl() {
    let pathname = window.location.pathname;
    let currentTopnavItem = NAV_LINKS.find(i => pathname.match('^' + i.path));
    let children = currentTopnavItem.children || [];
    let index = children.findIndex(c => pathname.match('^' + c.path));
    if (index < 0 || index+1 >= children.length) {
      return pathname;
    }
    return children[index + 1].path;
  }
}


Sitemap.Factory = class {
  create() {
    return _instance;
  }
}


const _instance = new Sitemap();


export default Sitemap;

